module.exports = __webpack_public_path__ + "static/duhan-pinduk-a93620c3c279efc754b20066bf023081.webp";